import { render, staticRenderFns } from "./number-arrow-select.vue?vue&type=template&id=574d89e5&scoped=true"
import script from "./number-arrow-select.vue?vue&type=script&lang=js"
export * from "./number-arrow-select.vue?vue&type=script&lang=js"
import style0 from "./number-arrow-select.vue?vue&type=style&index=0&id=574d89e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574d89e5",
  null
  
)

export default component.exports